const normalizeValue = (value: unknown) => {
  const normalized = String(value ?? "").trim();
  if (
    !normalized ||
    normalized === "0" ||
    normalized.toLowerCase() === "null" ||
    normalized.toLowerCase() === "undefined"
  ) {
    return null;
  }
  return normalized;
};

const getDeletedDocumentKey = (record: any) => {
  const directId = normalizeValue(
    record?.application_document_id ??
      record?.ApplicationDocumentID ??
      record?.ApplicationDocumentId ??
      record?.app_doc_id ??
      record?.AppDocID ??
      record?.DocumentID ??
      record?.DocumentId
  );
  if (directId) return `doc:${directId}`;

  const blobPath = normalizeValue(record?.BlobPathfile ?? record?.path ?? record?.file_path);
  if (blobPath) return `blob:${blobPath}`;

  const components = [
    record?.DocumentTypeID,
    record?.EmployerNumber,
    record?.BankStatementNumber,
    record?.OtherIncomeNumber,
    record?.CreatedOn,
  ].map((value) => normalizeValue(value) || "");
  if (components.every((c) => c === "")) return null;
  return components.join(":");
};

export const countUniqueDeletedDocuments = (records: any[] | undefined | null) => {
  if (!Array.isArray(records)) return 0;

  const keys = new Set<string>();
  records.forEach((record) => {
    const key = getDeletedDocumentKey(record);
    if (key) keys.add(key);
  });
  return keys.size;
};
